import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const home = () => import("@/views/Home.vue");
const about = () => import("@/views/About.vue");
const products = () => import("@/views/Products.vue");
const service = () => import("@/views/Ncov.vue");
const mngs = () => import("@/views/Mngs.vue");
const hrgm = () => import("@/views/Hrgm.vue");
const detection = () => import("@/views/Tumour.vue");
const news = () => import("@/views/News.vue");
const contact = () => import("@/views/Contact.vue");
const report = () => import("@/views/Report.vue");

const news_detail = () => import("@/views/News_detail.vue");
const detection_detail = () => import("@/views/Tumour_detail.vue");
const paternity = () => import("@/views/Paternity_testing.vue");
const recruitment = () => import("@/views/Recruitment.vue");
const contact_detail = () => import("@/views/Contact_detail.vue");

const folate_metabolism = () => import("@/views/hrgm/Folate_metabolism.vue");
const alcohol_metabolism = () => import("@/views/hrgm/Alcohol_metabolism.vue");
const motor_gene = () => import("@/views/hrgm/Motor_gene.vue");
const tumor_screening = () => import("@/views/hrgm/Tumor_screening.vue");

export default new Router({
  // mode: "history",
  base: process.env.BASE_URL,
  routes: [
    //首页
    {
      path: "",
      redirect: {
        name: 'home'
      }
    },
    {
      path: "/",
      name: "home",
      component: home
    },
    {
      path: "/report",
      name: "report",
      component: report
    },
    //关于我们
    {
      path: "/about",
      name: "about",
      component: about
    },
    {
      path: "/about/:id",
      name: "About",
      component: about
    },
    //产品中心
    {
      path: "/products",
      name: "product",
      component: products
    },
    // 亲缘关系鉴定
    {
      path: "/products/paternity-testing",
      name: "paternity",
      component: paternity,
      meta: { activeMenu: 'product' }
    },
    //新冠检测
    {
      path: "/products/ncov",
      name: "service",
      component: service
    },
    //病原微生物检测
    {
      path: "/products/mngs",
      name: "mngs",
      component: mngs,
      meta: { activeMenu: 'product' }
    },
    //健康风险基因管理
    {
      path: "/products/hrgm",
      name: "hrgm",
      component: hrgm
    },
    // 叶酸代谢
    {
      path: "/products/hrgm/folate_metabolism",
      name: "folate_metabolism",
      component: folate_metabolism,
      meta: { activeMenu: 'hrgm' }
    },
    // 酒精代谢
    {
      path: "/products/hrgm/alcohol_metabolism",
      name: "alcohol_metabolism",
      component: alcohol_metabolism,
      meta: { activeMenu: 'hrgm' }
    },
    // 运动基因
    {
      path: "/products/hrgm/motor_gene",
      name: "motor_gene",
      component: motor_gene,
      meta: { activeMenu: 'hrgm' }
    },
    // 遗传性肿瘤易感性筛查
    {
      path: "/products/hrgm/tumor_screening",
      name: "tumor_screening",
      component: tumor_screening,
      meta: { activeMenu: 'hrgm' }
    },
    //肿瘤检测
    {
      path: "/products/tumour",
      name: "detection",
      component: detection
    },
    //肿瘤检测详情
    {
      path: "/products/tumour/:name",
      name: "detection_detail",
      component: detection_detail,
      meta: { activeMenu: 'detection' }
    },
    //新闻动态
    {
      path: "/news",
      name: "news",
      component: news
    },
    //新闻动态详情页
    {
      path: "/news/news_detail",
      name: "news_detail",
      component: news_detail,
      meta: { activeMenu: 'news' }
    },
    //加入我们
    {
      path: "/contact",
      name: "contact",
      component: contact
    },
    //加入我们列表
    {
      path: "/contact/recruitment",
      name: "recruitment",
      component: recruitment,
      meta: { activeMenu: 'contact' }
    },
    //加入我们详情
    {
      path: "/contact/recruitment/contact_detail",
      name: "contact_detail",
      component: contact_detail,
      meta: { activeMenu: 'contact' }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js